import { Component } from '@angular/core';

@Component({
    selector: 'calls', template: '<router-outlet></router-outlet>',
    standalone: false
})
export class CallsComponent {}
